// Ödemeler ekranı için ortak etiket/biçimlendirme yardımcıları.

export const PACKAGE_LABELS: Record<string, string> = {
  day_1: "1 Günlük",
  week_1: "1 Haftalık",
  month_1: "1 Aylık",
  month_3: "3 Aylık",
  month_6: "6 Aylık",
  month_9: "9 Aylık",
  month_12: "12 Aylık",
  custom: "Özel Süre",
};

// Siparişin paket adı. Paketler panelden yönetildiği için ad siparişe kopyalanır (quote.package):
// paket sonradan yeniden adlandırılsa/silinse de kayıt satın alındığı günkü adıyla görünür.
// PACKAGE_LABELS yalnız bu kopyanın olmadığı eski siparişler içindir.
export function getPackageLabel(order?: { packageId?: string; quote?: any } | null): string {
  if (!order) return "";
  return order.quote?.package?.label || PACKAGE_LABELS[order.packageId || ""] || order.packageId || "";
}

export const PAYMENT_SOURCE_LABELS: Record<string, string> = {
  iyzico: "iyzico",
  param: "Param",
  esnekpos: "EsnekPos",
  tami: "Tami",
  cash: "Nakit",
  free: "Ücretsiz",
  card: "Kart",
};

export const ORDER_STATUS_LABELS: Record<string, string> = {
  PENDING: "Bekliyor",
  PAID: "Ödendi",
  FAILED: "Başarısız",
  CANCELLED: "İptal",
  REFUNDED: "İade",
};

export const ORDER_STATUS_CLASSES: Record<string, string> = {
  PENDING: "bg-amber-50 text-amber-700",
  PAID: "bg-emerald-50 text-emerald-700",
  FAILED: "bg-red-50 text-red-700",
  CANCELLED: "bg-slate-100 text-slate-600",
  REFUNDED: "bg-slate-100 text-slate-600",
};

export function formatMoney(value: string | number | undefined | null): string {
  return Number(value || 0).toLocaleString("tr-TR", { style: "currency", currency: "TRY" });
}

export function formatDateTime(value?: string | null): string {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

// Kalan süreyi insan diliyle: "3 gün 4 saat", "2 saat 10 dk", "bitti"
export function formatRemaining(ms: number): string {
  if (!ms || ms <= 0) return "Bitti";
  const totalMinutes = Math.floor(ms / 60000);
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return `${days} gün ${hours} sa`;
  if (hours > 0) return `${hours} sa ${minutes} dk`;
  return `${minutes} dk`;
}

export function fullName(person?: { firstName?: string; lastName?: string } | null): string {
  if (!person) return "";
  return `${person.firstName || ""} ${person.lastName || ""}`.trim();
}
